export const Monogram = ({ className = "h-10 w-auto", variant = "plum" }) => (
  <img
    src={variant === "cream" ? "/monogram-cream.png" : "/monogram-plum.png"}
    alt="House of Alvirah monogram"
    className={`${className} object-contain`}
  />
);
